module.exports = __webpack_public_path__ + "static/img/wisdom_park2.642d6377.png";